/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { getId } from '@fluentui/react/lib/Utilities';
import { getScopedTheme } from 'src/core/themes/luisStylist';

const theme = getScopedTheme('Renderers');

export const shapeClassName = getId('shape');
export const contextualMenuClassName = '.ms-Callout';
export const tokenContainerDataAttribute = 'data-container-id';

export const tokenDataAttribute = 'data-is-token';
export const bracketDataAttribute = 'data-is-bracket';
export const tokenIndexDataAttribute = 'data-token-index';

/**
 * Entity depth color schema.
 */
export const depthColorsMap: { [key: number]: string } = {
    1: theme.depth1Color,
    2: theme.depth2Color,
    3: theme.depth3Color,
    4: theme.depth4Color,
    5: theme.depth5Color
};

export const SHAPE_LEVEL_HEIGHT = 18;
export const SHAPE_LEVEL_HEIGHT_NO_NAME = 6;

export const SHAPE_HORIZONTAL_MARGIN = 4;

export const MULTI_LINE_MARGIN = 6;

export const SHAPE_DEPTH_ONE_THICKNESS = 2;
export const SHAPE_THICKNESS = 1;

export const RESIZE_HANDLE_DEPTH_ONE_SIZE = 4;
export const RESIZE_HANDLE_SIZE = 3;

export const LABEL_Z_INDEX = 1;
export const TOKEN_Z_INDEX = 1;
